// extracted by mini-css-extract-plugin
export var container = "_3t-0";
export var icon = "_3t-1";
export var text = "_3t-2";